import {required,numeric} from "vuelidate/lib/validators";  
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric"; 
const StrPerfRaporGiris = {
  mixins: [Api, Sabit],
    data() {
      return { 
        StrPerfRaporGirisData:{
            Id: "",
            Deleted: false,
            Deger: 0,
            Aciklama:"",
            Onay: 0,
            Donemid:"",
            Birimid:"",
            Detayid:"",   
            Ilkonaytarihi: "",
            Onaysayisi: 0,
          },
        FormDataType:{ 
        
          Aciklama:{FieldName:"Aciklama",Field:"input",FieldTitle:"Dosya Yolu",FieldType:"text"},
          Deger:{FieldName:"Deger",Field:"input",FieldTitle:"",FieldType:"number"},
          Onay:{FieldName:"Onay",Field:"input",FieldTitle:"Onay",FieldType:"number"},
          Donemid:{FieldName:"Donemid",Field:"combobox",FieldTitle:"Dönem"},
          Birimid:{FieldName:"Birimid",Field:"combobox",FieldTitle:"Birim"},
          Detayid:{FieldName:"Detayid",Field:"combobox",FieldTitle:"Gösterge"},
          Ilkonaytarihi:{FieldName:"Ilkonaytarihi",Field:"input",FieldTitle: "İlk Onay Tarihi",FieldType:"date"},
          Onaysayisi:{FieldName:"Onaysayisi",Field:"input",FieldTitle:"Onay Sayisi",FieldType:"number"},
          
        }   
      }
    },
    validations:{ 
        FormData: {
       
          Aciklama: { required },
          Deger: {  },
          Onay: { required,numeric },
          Donemid: { required },
          Birimid: { required },
          Detayid: { required },
          Onaysayisi: { },
          Ilkonaytarihi: { }
           
        } 
    },


    created(){ 


      
    }

}
export default StrPerfRaporGiris